<template>
  <div
    class="property-photos-modal bg-black bg-opacity-90 fixed inset-0 z-10"
  >
    <swiper
      :centered-slides="true"
      :initial-slide="initialSlide"
      :lazy="{checkInView: true, loadPrevNext: true}"
      :loop="true"
      :navigation="true"
      :slides-per-view="'auto'"
      :space-between="24"
      :swiper-pagination-clickable="true"
    >
      <swiper-slide
        v-for="photo in filteredPhotos"
        :key="photo.media_key"
      >
        <!--suppress RequiredAttributes -->
        <img
          :alt="photo.short_description || 'Missing photo description'"
          class="swiper-lazy"
          :data-src="photo.media_url"
          @click="$emit('clickClose')"
        >
        <div
          class="swiper-lazy-preloader swiper-lazy-preloader-white"
        />
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import SwiperCore, { Navigation, Lazy } from 'swiper/core';
import { Swiper, SwiperSlide } from 'swiper/vue';

import getPropertyPhotos from '../helpers/getPropertyPhotos';

export default {
  name: 'PropertyPhotosModal',

  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    property: {
      required: true,
      type: Object,
    },
    initialSlide: {
      type: Number,
      default: 0,
    },
  },
  emits: ['clickClose'],

  computed: {
    filteredPhotos() {
      return getPropertyPhotos(this.property);
    },
  },
  created() {
    SwiperCore.use([
      Navigation, Lazy,
    ]);
  },
};
</script>

<style lang="scss">
.property-photos-modal {
  > .swiper-container {
    height: 100%;

    .swiper-slide > img {
      object-fit: contain;
      height: 100%;
      width: 100%;
    }
  }
}
</style>
